
    const data = {"name":"src/core/icons/logout","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M16 17v-3H9v-4h7V7l5 5-5 5M14 2a2 2 0 0 1 2 2v2h-2V4H5v16h9v-2h2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            